import { useQuery } from "@tanstack/react-query";
import { getTripadvisorReviewsStatus } from "../../api/bReviewsApi";

export const useGetTripadvisorReviewsStatus = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["tripadvisor-reviews-status", organisationId],
    queryFn: () => getTripadvisorReviewsStatus(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
};
